import React, { useContext } from 'react'
import { Carousel } from "react-bootstrap/esm/index.js";
import './Testimony.css'
import Rating from './Rating.png'
import Tes1 from './Tes1.png'
import Tes2 from './Tes2.png'
import Tes3 from './Tes3.png'
import Tes4 from './Tes4.png'
import Tes5 from './Tes5.png'
import { GlobalContext } from '../../../Context/GlobalContext';


function Testimony() {
    const { matches } = useContext(GlobalContext)

    return (
        <div className='testimony'>
            <h5>Every Mom Loves BumpCare</h5>
            {matches ?
                <Carousel>
                    <Carousel.Item>
                        <div className='tes-container'>
                            <div className='tes2'>
                                <div className='tes-child1'>
                                    <h5>"Great resource for expecting mothers"</h5>
                                    <p>I used this website to find a gynecologist when I first found
                                        out I was pregnant. The website was very user-friendly and
                                        I was able to find a doctor who specialized in obstetrics.
                                        Throughout my pregnancy, my doctor provided me with
                                        excellent care and guidance. I would definitely recommend
                                        this website to any expecting mother.
                                    </p>
                                </div>
                                <div className='tes-child2'>
                                    <div className='tes-dt'>
                                        <h5>George Isabella</h5>
                                        <img src={Rating} alt='Rating' />
                                    </div>
                                    <img src={Tes1} alt='testifier' />
                                </div>
                            </div>
                        </div>
                    </Carousel.Item>
                    <Carousel.Item>
                        <div className='tes-container'>
                            <div className='tes2'>
                                <div className='tes-child1'>
                                    <h5>"Ultimate Guide To Pregnancy Care"</h5>
                                    <p>As a first-time mother, I was overwhelmed and anxious about my
                                        pregnancy journey. Thankfully, I discovered this incredible pregnancy
                                        care resource website that became my ultimate guide. From pre-
                                        conception, tips to weekly updates on my baby's development, the
                                        website provided comprehensive informations that answered all my
                                        questions. The articles were well-researched, easy to understand, and
                                        covered various aspects of pregnancy care, including nutrition,
                                        exercise, and emotional well-being.Thanks to this invaluable resource,
                                        I felt empowered and confident throughout my pregnancy, knowing
                                        that I had access to reliable information whenever I needed it.
                                    </p>
                                </div>
                                <div className='tes-child2'>
                                    <div className='tes-dt'>
                                        <h5>Beebe J</h5>
                                        <img src={Rating} alt='Rating' />
                                    </div>
                                    <img src={Tes2} alt='testifier' />
                                </div>
                            </div>

                        </div>
                    </Carousel.Item>
                    <Carousel.Item>
                        <div className='tes-container'>
                            <div className='tes2'>
                                <div className='tes-child1'>
                                    <h5>"Best Childbirth Resources"</h5>
                                    <p>I cannot stress enough how grateful I am for the childbirth
                                        resources provided by this website. The moment I found out I was
                                        expecting, I knew I needed to educate myself about Childbirth, but
                                        I had no idea where to start. This website came to my rescue with
                                        its wealth of knowledge on different birthing options, pain
                                        management techniques, and even advice on creating a birth plan
                                        The articles were incredibly detailed, and I appreciated That
                                        they presented a balanced view, allowing me to make informed
                                        decisions based on my preferences and circumstances. Thanks to
                                        these invaluable resources, I entered the delivery room feeling
                                        confident, supported, and prepared for the beautiful journey of
                                        bringing my baby into this world.
                                    </p>
                                </div>
                                <div className='tes-child2'>
                                    <div className='tes-dt'>
                                        <h5>Maria F</h5>
                                        <img src={Rating} alt='Rating' />
                                    </div>
                                    <img src={Tes3} alt='testifier' />
                                </div>
                            </div>
                        </div>
                    </Carousel.Item>
                    <Carousel.Item>
                        <div className='tes-container'>
                            <div className='tes2'>
                                <div className='tes-child1'>
                                    <h5>"Satisfied Mother"</h5>
                                    <p>I cannot express my gratitude enough  for this prenancy care and
                                        gynecologist directory website. It played a crucial role in my
                                        prenatal journey by connecting me with a compassionate and
                                        knowledgeable gynecologist. The testimonials shared by other
                                        mothers helped me narrow down my choices and select a
                                        gynecologist who was the perfect fit for me. The care and support
                                        I received from my chosen gynecologist were exceptional. Thanks
                                        to this website, I had a smooth and stress-free pregnancy
                                        experience. I wholeheartedly recommend this platform to all
                                        mothers in need of a reliable and trustworthy pregnancy care.
                                    </p>
                                </div>
                                <div className='tes-child2'>
                                    <div className='tes-dt'>
                                        <h5>Jessica M</h5>
                                        <img src={Rating} alt='Rating' />
                                    </div>
                                    <img src={Tes4} alt='testifier' />
                                </div>
                            </div>
                        </div>
                    </Carousel.Item>
                    <Carousel.Item>
                        <div className='tes-container'>
                            <div className='tes2'>
                                <div className='tes-child1'>
                                    <h5>"Quick and easy search"</h5>
                                    <p>I was new to the area and needed to find a gynecologist
                                        quickly. This website made the search process quick and
                                        easy. I was able to find a great doctor who is close to my
                                        home who has been so helpful and understanding. I am
                                        very satisfied with the service this website provided.
                                    </p>
                                </div>
                                <div className='tes-child2'>
                                    <div className='tes-dt'>
                                        <h5>Mary J</h5>
                                        <img src={Rating} alt='Rating' />
                                    </div>
                                    <img src={Tes5} alt='testifier' />
                                </div>
                            </div>
                        </div>
                    </Carousel.Item>
                </Carousel>
                :
                <Carousel>
                    <Carousel.Item>
                        <div className='static-container'>
                            <div className='tes-container'>
                                <div className='tes1'>
                                    <div className='tes-child1'>
                                        <h5>"Great resource for expecting mothers"</h5>
                                        <p>I used this website to find a gynecologist when I first found
                                            out I was pregnant. The website was very user-friendly and
                                            I was able to find a doctor who specialized in obstetrics.
                                            Throughout my pregnancy, my doctor provided me with
                                            excellent care and guidance. I would definitely recommend
                                            this website to any expecting mother.
                                        </p>
                                    </div>
                                    <div className='tes-child2'>
                                        <div className='tes-dt'>
                                            <h5>George Isabella</h5>
                                            <img src={Rating} alt='Rating' />
                                        </div>
                                        <img src={Tes1} alt='testifier' />
                                    </div>
                                </div>
                                <div className='tes2'>
                                    <div className='tes-child1'>
                                        <h5>"Ultimate Guide To Pregnancy Care"</h5>
                                        <p>As a first-time mother, I was overwhelmed and anxious about my
                                            pregnancy journey. Thankfully, I discovered this incredible pregnancy
                                            care resource website that became my ultimate guide. From pre-
                                            conception, tips to weekly updates on my baby's development, the
                                            website provided comprehensive informations that answered all my
                                            questions. The articles were well-researched, easy to understand, and
                                            covered various aspects of pregnancy care, including nutrition,
                                            exercise, and emotional well-being.Thanks to this invaluable resource,
                                            I felt empowered and confident throughout my pregnancy, knowing
                                            that I had access to reliable information whenever I needed it.
                                        </p>
                                    </div>
                                    <div className='tes-child2'>
                                        <div className='tes-dt'>
                                            <h5>Beebe J</h5>
                                            <img src={Rating} alt='Rating' />
                                        </div>
                                        <img src={Tes2} alt='testifier' />
                                    </div>
                                </div>

                            </div>
                        </div>
                    </Carousel.Item>
                    <Carousel.Item>
                        <div className='static-container'>
                            <div className='tes-container'>
                                <div className='tes1'>
                                    <div className='tes-child1'>
                                        <h5>"Ultimate Guide To Pregnancy Care"</h5>
                                        <p>As a first-time mother, I was overwhelmed and anxious about my
                                            pregnancy journey. Thankfully, I discovered this incredible pregnancy
                                            care resource website that became my ultimate guide. From pre-
                                            conception, tips to weekly updates on my baby's development, the
                                            website provided comprehensive informations that answered all my
                                            questions. The articles were well-researched, easy to understand, and
                                            covered various aspects of pregnancy care, including nutrition,
                                            exercise, and emotional well-being.Thanks to this invaluable resource,
                                            I felt empowered and confident throughout my pregnancy, knowing
                                            that I had access to reliable information whenever I needed it.
                                        </p>
                                    </div>
                                    <div className='tes-child2'>
                                        <div className='tes-dt'>
                                            <h5>Beebe J</h5>
                                            <img src={Rating} alt='Rating' />
                                        </div>
                                        <img src={Tes2} alt='testifier' />
                                    </div>
                                </div>
                                <div className='tes2'>
                                    <div className='tes-child1'>
                                        <h5>"Best Childbirth Resources"</h5>
                                        <p>I cannot stress enough how grateful I am for the childbirth
                                            resources provided by this website. The moment I found out I was
                                            expecting, I knew I needed to educate myself about Childbirth, but
                                            I had no idea where to start. This website came to my rescue with
                                            its wealth of knowledge on different birthing options, pain
                                            management techniques, and even advice on creating a birth plan
                                            The articles were incredibly detailed, and I appreciated That
                                            they presented a balanced view, allowing me to make informed
                                            decisions based on my preferences and circumstances. Thanks to
                                            these invaluable resources, I entered the delivery room feeling
                                            confident, supported, and prepared for the beautiful journey of
                                            bringing my baby into this world.
                                        </p>
                                    </div>
                                    <div className='tes-child2'>
                                        <div className='tes-dt'>
                                            <h5>Maria F</h5>
                                            <img src={Rating} alt='Rating' />
                                        </div>
                                        <img src={Tes3} alt='testifier' />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Carousel.Item>
                    <Carousel.Item>
                        <div className='static-container'>
                            <div className='tes-container'>
                                <div className='tes1'>
                                    <div className='tes-child1'>
                                        <h5>"Best Childbirth Resources"</h5>
                                        <p>I cannot stress enough how grateful I am for the childbirth
                                            resources provided by this website. The moment I found out I was
                                            expecting, I knew I needed to educate myself about Childbirth, but
                                            I had no idea where to start. This website came to my rescue with
                                            its wealth of knowledge on different birthing options, pain
                                            management techniques, and even advice on creating a birth plan
                                            The articles were incredibly detailed, and I appreciated That
                                            they presented a balanced view, allowing me to make informed
                                            decisions based on my preferences and circumstances. Thanks to
                                            these invaluable resources, I entered the delivery room feeling
                                            confident, supported, and prepared for the beautiful journey of
                                            bringing my baby into this world.
                                        </p>
                                    </div>
                                    <div className='tes-child2'>
                                        <div className='tes-dt'>
                                            <h5>Maria F</h5>
                                            <img src={Rating} alt='Rating' />
                                        </div>
                                        <img src={Tes3} alt='testifier' />
                                    </div>
                                </div>
                                <div className='tes2'>
                                    <div className='tes-child1'>
                                        <h5>"Satisfied Mother"</h5>
                                        <p>I cannot express my gratitude enough  for this prenancy care and
                                            gynecologist directory website. It played a crucial role in my
                                            prenatal journey by connecting me with a compassionate and
                                            knowledgeable gynecologist. The testimonials shared by other
                                            mothers helped me narrow down my choices and select a
                                            gynecologist who was the perfect fit for me. The care and support
                                            I received from my chosen gynecologist were exceptional. Thanks
                                            to this website, I had a smooth and stress-free pregnancy
                                            experience. I wholeheartedly recommend this platform to all
                                            mothers in need of a reliable and trustworthy pregnancy care.
                                        </p>
                                    </div>
                                    <div className='tes-child2'>
                                        <div className='tes-dt'>
                                            <h5>Jessica M</h5>
                                            <img src={Rating} alt='Rating' />
                                        </div>
                                        <img src={Tes4} alt='testifier' />
                                    </div>
                                </div>

                            </div>
                        </div>
                    </Carousel.Item>
                    <Carousel.Item>
                        <div className='static-container'>
                            <div className='tes-container'>
                                <div className='tes1'>
                                    <div className='tes-child1'>
                                        <h5>"Satisfied Mother"</h5>
                                        <p>I cannot express my gratitude enough  for this prenancy care and
                                            gynecologist directory website. It played a crucial role in my
                                            prenatal journey by connecting me with a compassionate and
                                            knowledgeable gynecologist. The testimonials shared by other
                                            mothers helped me narrow down my choices and select a
                                            gynecologist who was the perfect fit for me. The care and support
                                            I received from my chosen gynecologist were exceptional. Thanks
                                            to this website, I had a smooth and stress-free pregnancy
                                            experience. I wholeheartedly recommend this platform to all
                                            mothers in need of a reliable and trustworthy pregnancy care.
                                        </p>
                                    </div>
                                    <div className='tes-child2'>
                                        <div className='tes-dt'>
                                            <h5>Jessica M</h5>
                                            <img src={Rating} alt='Rating' />
                                        </div>
                                        <img src={Tes4} alt='testifier' />
                                    </div>
                                </div>
                                <div className='tes2'>
                                    <div className='tes-child1'>
                                        <h5>"Quick and easy search"</h5>
                                        <p>I was new to the area and needed to find a gynecologist
                                            quickly. This website made the search process quick and
                                            easy. I was able to find a great doctor who is close to my
                                            home who has been so helpful and understanding. I am
                                            very satisfied with the service this website provided.
                                        </p>
                                    </div>
                                    <div className='tes-child2'>
                                        <div className='tes-dt'>
                                            <h5>Mary J</h5>
                                            <img src={Rating} alt='Rating' />
                                        </div>
                                        <img src={Tes5} alt='testifier' />
                                    </div>
                                </div>

                            </div>
                        </div>
                    </Carousel.Item>
                    <Carousel.Item>
                        <div className='static-container'>
                            <div className='tes-container'>
                                <div className='tes1'>
                                    <div className='tes-child1'>
                                        <h5>"Quick and easy search"</h5>
                                        <p>I was new to the area and needed to find a gynecologist
                                            quickly. This website made the search process quick and
                                            easy. I was able to find a great doctor who is close to my
                                            home who has been so helpful and understanding. I am
                                            very satisfied with the service this website provided.
                                        </p>
                                    </div>
                                    <div className='tes-child2'>
                                        <div className='tes-dt'>
                                            <h5>Mary J</h5>
                                            <img src={Rating} alt='Rating' />
                                        </div>
                                        <img src={Tes5} alt='testifier' />
                                    </div>
                                </div>
                                <div className='tes2'>
                                    <div className='tes-child1'>
                                        <h5>"Great resource for expecting mothers"</h5>
                                        <p>I used this website to find a gynecologist when I first found
                                            out I was pregnant. The website was very user-friendly and
                                            I was able to find a doctor who specialized in obstetrics.
                                            Throughout my pregnancy, my doctor provided me with
                                            excellent care and guidance. I would definitely recommend
                                            this website to any expecting mother.
                                        </p>
                                    </div>
                                    <div className='tes-child2'>
                                        <div className='tes-dt'>
                                            <h5>George Isabella</h5>
                                            <img src={Rating} alt='Rating' />
                                        </div>
                                        <img src={Tes1} alt='testifier' />
                                    </div>
                                </div>

                            </div>
                        </div>
                    </Carousel.Item>
                </Carousel>
            }
        </div>
    )
}

export default Testimony